import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './ad9511886054193cba05064cfab0382a17fe5fe87409dfd4e0f1420b3114f700.cfe-internal.js';
import Checkbox from './bbb86efee75a495b2eb803aad8b5e8c05236c93f8c0727ac51f1a82b7608b17b.cfe-internal.js';
import '../Label/ccb438053671d3f4f4866aeae6546c2d1a0a64aa48a3d0efdd175e4b2c5ded2e.cfe-internal.js';
import Label from '../Label/9a6a268368a265bce1daf89b3b2abe908557e75abd2903920d33084576c4c867.cfe-internal.js';

var _excluded = ["id", "label", "checked", "defaultChecked", "onChange", "disabled", "value", "className", "inputProps", "aria-describedby"];
var CheckboxField = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    label = _ref.label,
    checked = _ref.checked,
    defaultChecked = _ref.defaultChecked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    value = _ref.value,
    className = _ref.className,
    inputProps = _ref.inputProps,
    ariaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement(Label, _extends({}, rest, {
    ref: ref,
    htmlFor: id,
    className: classNames(className, styles.label, _defineProperty({}, styles.labelDisabled, disabled))
  }), /*#__PURE__*/React__default.createElement(Checkbox, {
    inputProps: inputProps,
    className: styles.wrappedInput,
    id: id,
    checked: checked,
    defaultChecked: defaultChecked,
    disabled: disabled,
    onChange: onChange,
    value: value,
    "aria-describedby": ariaDescribedBy
  }), label);
});

export { CheckboxField as default };
